



























































































































import { Vue, Component, Prop } from "vue-property-decorator";
import CardTitle from "../../components/CardTitle.vue";
import * as activity from "../../_store/activity.module";
import * as user from "../../_store/user.module";
import * as auth from "../../_store/auth.module";
import { Activities } from "../../_models/activities";
import NoActivity from "../../components/Error/NoActivity.vue";
import { bus } from "../../main";
import { userUtils } from "../../_utils/userUtils";
import * as data from "../../_store/data.module";
import { router } from "../../_router";
import EditDialog from "../../components/Edit/EditDialog.vue";
import CreateDialog from "../../components/Dialogs/CreateDialog.vue";
import QuestionarioDialog from "../../components/Dialogs/QuestionarioDialog.vue";

@Component({
  components: {
    CardTitle,
    NoActivity,
    EditDialog,
    CreateDialog,
    QuestionarioDialog
  }
})
export default class WorkshopAzienda extends Vue {
  @Prop() idIscrizioneAttivita!: number;
  @Prop() idIstituto!: number;
  @Prop() idAnnoScolastico!: number;
  @Prop() statoPeriodoIscrizione!: boolean;
  @Prop() dataFineAttivita!: string;

  private titleParams: object;
  private workshopStatus: boolean;

  private listaPreferenze: any;
  private cognomeReferente: string;
  private nomeReferente: string;
  private emailReferente: string;

  private showEdit: boolean;
  private showCreate: boolean;
  private createDialogParams: any;

  private enableChanges: boolean;
  private dialogParams: any;
  private info: any;
  private activityType: string;

  constructor() {
    super();
    this.titleParams = {
      title: "Workshop",
      cols: "10",
      sm: "5",
      md: "5",
      lg: "4"
    };
    this.workshopStatus = false;
    this.listaPreferenze = [];
    this.cognomeReferente = "";
    this.nomeReferente = "";
    this.emailReferente = "";
    this.showEdit = true;
    this.showCreate = true;
    this.createDialogParams = {
      idIstituto: this.idIstituto,
      isIscrizioneAttivita: this.idIscrizioneAttivita,
      type: "nuovaPreferenzaWorkshop"
    };
    //this.enableChanges = this.statoPeriodoIscrizione;
    this.enableChanges = true;
    this.dialogParams = {
      title: "QUESTIONARIO WORKSHOP"
    };
    this.info = {
      idRichiesta: this.idIscrizioneAttivita,
      dataFineAttivita: this.dataFineAttivita
    };
    this.activityType = "workshop";
  }

  // this.wrapperIdRichiesta = {
  //     idRichiesta: this.idRichiesta
  //   };
  //   this.wrapperDialogTitle = {
  //     title: "QUESTIONARIO P.C.T.O."
  //   };

  deletePreferenza(idInformazioneWorkshop: number) {
    if (confirm("Cancellare Preferenza Settore?")) {
      user
        .dispatchDeletePreferenzaWorkshop(
          this["$store"],
          idInformazioneWorkshop
        )
        .then(() => {
          bus.$emit(
            "successfullOperation",
            "Preferenza Settore cancellata con successo"
          );
          this.loadPreferenzeWorkshop();
        })
        .catch(error => {
          if (error.response.status === 403) {
            bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
            this["$router"].push("/login");
          } else {
            bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
          }
        });
    }
  }

  loadPreferenzeWorkshop() {
    data
      .dispatchPreferenzeWorkshopAzienda(
        this["$store"],
        this.idIscrizioneAttivita
      )
      .then(result => {
        this.listaPreferenze = result;
        this.enableChanges = this.statoPeriodoIscrizione;
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
        }
      });
  }

  created() {
    if (
      this.idIscrizioneAttivita !== undefined &&
      this.idIscrizioneAttivita !== null
    ) {
      var token = localStorage.getItem("userToken");
      var parsedToken: any;
      if (token !== null) {
        parsedToken = userUtils.parseToken(token);
      }
      var payload = {
        idUtente: parsedToken.IdUtente,
        tipoSoggetto: parsedToken.IdTipoSoggetto,
        username: parsedToken.Username
      };
      user
        .dispatchSetUserInfo(this["$store"], payload)
        .then(() => {
          user
            .dispatchSetEnterpriseInfo(this["$store"])
            .then(() => {
              bus.$emit("loadMenu");
              var enterpriseInfo = user.readEnterpriseInfo(this["$store"]);
              var activities: Activities[];
              this.workshopStatus = true;
              this.loadPreferenzeWorkshop();
            })
            .catch(() => {
              bus.$emit("stopLoading");
              auth.dispatchLogout(this["$store"]);
              user.dispatchClearState(this["$store"]);
              this["$router"].push("/sessionExpired");
            });
        })
        .catch(() => {
          bus.$emit("stopLoading");
          auth.dispatchLogout(this["$store"]);
          user.dispatchClearState(this["$store"]);
          this["$router"].push("/sessionExpired");
        });
    } else {
      router.push({
        name: "iscrizioniWorkshop",
        params: {}
      });
    }

    bus.$on("loadPreferenzeWorkshop", async () => {
      this.showEdit = false;
      this.showCreate = false;
      await this.$nextTick();
      this.showEdit = true;
      this.showCreate = true;
      this.loadPreferenzeWorkshop();
    });
  }
}
